import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './_sizes.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HashRouter } from 'react-router-dom';
import Api from './api/Api';
import UIContainer, { UIWhiteBox } from './ui/UIContainer';
import Flex from './data/Flex';
import UIButton from './ui/UIButton';
import UITitle from './ui/UITitle';
import BrowserUtil from './util/BrowserUtil';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


BrowserUtil.setup();

Api.loadConfig(($success,$result)=>{
    if($success){
        root.render(
            <React.StrictMode>
                <HashRouter>
                    <App/>
                </HashRouter>
            </React.StrictMode>
        );
    }else{
        root.render(
            <UIContainer flex={{style:{height:"100%"}, justifyContent:Flex.CENTER, alignItems:Flex.CENTER}}>
                <UIWhiteBox flex={{justifyContent:Flex.CENTER, alignItems:Flex.CENTER}}>
                    <UITitle title={"Oops! A Config Error Occured"} marginBottom/>
                    <UIButton label={"Try Again"} onClick={()=>{
                        window.location.reload();
                    }}/>
                </UIWhiteBox>
            </UIContainer>
        )
    }
});





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
